import React, { ReactNode } from "react"
import ButtonComponent from "../Button/ButtonComponent";
import SvgComponent from "../Image/SvgComponent";

interface HeaderButtonProps {
    label: string;
    value: string;
    icon: ReactNode;
    active: boolean;
    disabled?: boolean;
    onClickOption: (value: any) => void;
}

const HeaderButtonComponent = (props: HeaderButtonProps) => {
    return <ButtonComponent
        id={`header_button_${props.value.toLowerCase()}`}
        key={`header_button_${props.value.toLowerCase()}`}
        type="button"
        sx={{
            display: "flex",
            flexDirection: "column",
            // height: "44px",
            //backgroundColor: ,
            color: props.active ? "#EF4444" : "#6A7282",
            textTransform: "inherit",
            borderTop: props.active ? "1.07px solid var(--color-red-45, #E7000B)" : "",
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            // fontFamily: '"Font 3", "Roboto", "Helvetica", "Arial", sans-serif',
            // fontWeight: 400,        // Regular
            // fontSize: '1.25rem',   // 20px / 16px
            // lineHeight: 1.4,       // 28px / 20px
            // letterSpacing: '0em',
            // textAlign: 'center',
            // display: 'flex',
            // alignpropss: 'center',
            // justifyContent: 'center',
            height: "100%",
            width: 368
        }}
        onClick={(event) => props.onClickOption(props.value)}
        disabled={props.disabled}
    >
        <SvgComponent 
            icon={props.icon}
            sx={{
                display: "flex",
                alignpropss: "center",
                justifyContent: "center",
                height: 18,
                width: 18,
                "& svg, & svg *": {
                    //fill: props.active ? "#EF4444" : "#6A7282",
                    stroke: props.active ? "#EF4444" : "#6A7282",
                },
            }}
        />
        
        {props.label}
    </ButtonComponent>
}

export default HeaderButtonComponent